module.exports = __webpack_public_path__ + "img/certificateConformity.a44b96cf.jpg";